// Whether the v2 product/participant flow is enabled in the patient dashboard.
// Mirrors the dashboard's EXPO_PUBLIC_ENABLE_V2_PRODUCTS gate so admin-generated
// links match what the dashboard actually renders. Toggle via
// VITE_ENABLE_V2_PRODUCTS ("true" to enable).
export function isV2ProductsEnabled(): boolean {
  return (
    (import.meta.env.VITE_ENABLE_V2_PRODUCTS as string | undefined) === "true"
  );
}
